import { subtract } from "ramda";
import { type EventModel } from "../types/graphql";

/**
 * Seat-holders: pending (initial) invites hold a seat, so capacity math
 * ("event full", "places remaining") must count them. Display counts use
 * `noParticipants` (accepted only) — never this. hey-lady#4477.
 */
export const countableParticipants = (event: EventModel): number =>
  event.noCountableParticipants ?? event.noParticipants ?? 0;

export const calculateFreeSeats = (event: EventModel) => {
  if (
    (event.maxParticipants && event.noParticipants) ||
    (event.maxParticipants && event.noParticipants === 0)
  ) {
    return subtract(event.maxParticipants, countableParticipants(event));
  }
};
